export default __webpack_public_path__ + "static/media/Alyssa_Hulme_AHV_In_Moms_We_Trust.c17efce5.jpg";